import type { JobDataInput } from "../../../__generated__/types.gqlgenerated";

const SAVED_JOB_FROM_LIST = [
  "app-tracker-saved-appcard",
  "savedjoblist",
  "app-tracker-saved-applybtn",
  // RN MyJobs Saved tab (replaces the native `app-tracker-saved-*` flow as
  // the RN MyJobs rollout grows). See SavedJobCard.tsx in apps/myjobs.
  "myjobs-saved",
  "myjobs-saved-apply",
];

const APPSHARE_FROM_LIST = ["appshareios", "appsharedroid", "appshareandroid"];

const CAREER_SCOUT_FROM_LIST = ["career_scout_chat"];

function getPlacementIdFromFrom(from: string): string | null {
  if (SAVED_JOB_FROM_LIST.includes(from)) {
    return "indeed-feed-savedjob";
  }
  if (APPSHARE_FROM_LIST.includes(from)) {
    return "indeed-appshare";
  }
  if (CAREER_SCOUT_FROM_LIST.includes(from)) {
    return "indeed-ace-chatbot";
  }

  return null;
}

export function getPlacementIdFromUrl(url: string | null): string | null {
  if (url === null) {
    return null;
  }
  try {
    const from = new URL(url).searchParams.get("from") ?? "";
    return getPlacementIdFromFrom(from);
  } catch {
    return null;
  }
}

/**
 * Constructs the JobDataInput for the jobDataResult query (jobDataResult.graphql).
 *
 * For searchless sources (saved jobs, app share), sets `useSearchlessPrice: true`
 * so JRS returns correct sponsorship data in tracking.jobClick.url. Without this flag,
 * JRS treats the request as organic and the jobClick URL won't reflect the actual
 * sponsored status — breaking the client-side spn override
 * (see overrideSponsoredFromJobClickUrl in useApplyLink.ts).
 */
export function getJobDataInput(url: string, jobKey: string): JobDataInput {
  const placementId = getPlacementIdFromUrl(url);
  if (placementId) {
    return { jobKeys: [jobKey], useSearchlessPrice: true, placementId };
  }
  return { jobKeys: [jobKey] };
}
